import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClienteFilial } from '../persistences/cliente-filial';
import { ConfigService } from './config.service';


@Injectable({
	providedIn: 'root'
})
export class ClienteService {

	constructor(
		private httpClient: HttpClient,
		private configService: ConfigService,
	) { }

	getCliente() {
		let httpParams = new HttpParams();
		httpParams = httpParams
			.append('id', localStorage.getItem('cd_cliente'));


		return this.httpClient.get(
			this.configService.getEndereco() + '/Cliente/getById',
			{
				headers: this.configService.getHeaders(),
				params: httpParams
			}
		)
	}

	getClienteFilial(cdFilial: number): Observable<ClienteFilial> {
		let httpParams = new HttpParams();
		httpParams = httpParams
			.append('cdFilial', cdFilial.toString());
		return this.httpClient.get<ClienteFilial>(
			this.configService.getEndereco() + '/Filial/getByCdFilial',
			{
				headers: this.configService.getHeaders(),
				params: httpParams
			}
		)
	}
}
